// Constants
export const datos_proveedores_lente = () => {
  return {
    datos_proveedores_lente: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        dataform: ['proveedor_lente'],
        datatype: {
          predeterminate: ''
        }
      },
      name: {
        type: 'text',
        label: 'Nombre',
        dataform: ['proveedor_lente'],
        placeholder: '',
        description: 'nombre completo',
        prepend: '',
        append: '',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      }, 
      documento: {
        type: 'number', 
        dataform: ['proveedor_lente'],
        label: 'Documento',
        placeholder: '',
        description: 'documento',
        validate: 'required|maxLength:15',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: 0,
          append: '',
          prepend: '',
        }
      },   
      direccion: {
        type: 'text',
        label: 'Direccion',
        dataform: ['proveedor_lente'],
        placeholder: '',
        description: 'Dirección y barrio',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',         
        }
      },  
      ciudad: {
        type: 'text',
        label: 'Ciudad',
        dataform: ['proveedor_lente'],
        placeholder: '',
        description: 'Dirección y barrio',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      }, 
      telefonos: {
        type: 'text',
        label: 'Teléfonos',
        dataform: ['proveedor_lente'],
        placeholder: '',
        description: 'No. de telefonos',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      email: {
        type: 'text',
        label: 'Email',
        dataform: ['proveedor_lente'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },    
    }  
  }
}

export function asign_datos_proveedores_lente(){
  var asign= Object.keys(datos_proveedores_lente().datos_proveedores_lente);
  var objeto = datos_proveedores_lente().datos_proveedores_lente
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

